import React, { useEffect, useState } from 'react';
import './ContractDetails.css';
import Sidebar from '../Header&SIdebar/sidebar';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const ContractDetails = () => {
  const { id } = useParams(); // Получаем id контракта из URL
  const [contractItems, setContractItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContractItems = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/contractitems/contract/${id}`, {
          headers: {
            'x-api-key': '12345xxa',
          },
        });

        if (response.data.length > 0) {
          setContractItems(response.data);
        } else {
          console.log('Позиции для данного договора не найдены.');
          setContractItems([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Ошибка при получении данных о позициях контракта:', error);
        setLoading(false);
      }
    };

    fetchContractItems();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return 'Не указано';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('ru-RU', options);
  };

  return (
    <div className="contracts-list-container">
      <Sidebar />
      <div className="contract-details-container">
        <h2>Детали договора № {id}</h2>
        {loading ? (
          <div>Загрузка...</div>
        ) : contractItems.length === 0 ? (
          <div>Позиции для данного договора не найдены.</div>
        ) : (
          <div className="contract-items-table">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Наименование товара</th>
                  <th>Количество</th>
                  <th>Ед. изм.</th>
                  <th>Цена</th>
                  <th>Сумма</th>
                  <th>Остаток Кол-во</th>
                  <th>Дата создания</th>
                </tr>
              </thead>
              <tbody>
                {contractItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.product_name}</td>
                    <td>{item.quantity}</td>
                    <td>{item.measure_name}</td>
                    <td>{item.price}</td>
                    <td>{item.amount}</td>
                    <td>{item.balance}</td>
                    <td>{formatDate(item.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractDetails;
